import React from 'react'
import ClassesDataForm from './ClassesDataForm'

const EditClasses = () => {
  return (
    <div>
      <ClassesDataForm action="Edit"/>
    </div>
  )
}

export default EditClasses
